import axios from 'axios';

export default function(URL, filename, callback, isFull = false, withoutToken = false) {
  let urlDownload = '/api/download/files/' + URL;
  if (withoutToken === true) {
    urlDownload = '/api/download/withoutToken/files/' + URL;
  }
  if (isFull === true) {
    urlDownload = URL;
  }
  axios({
    url: urlDownload,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    if (typeof callback === 'function') {
      callback();
    }
  });
}




// WEBPACK FOOTER //
// ./src/components/utils/download.jsx